// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__QKp5r","upload":"Small_upload__3xm_7","imageWrap":"Small_imageWrap__b96pv","removeBtn":"Small_removeBtn__TZUJj"};